import { withSuspense } from '@unifyapps/hooks/withSuspense';
import { forwardRef } from 'react';
// import { useClientContext } from '../../context/client/ClientContext';
// import { ClientType } from '../../context/client/types';
import { dynamic } from '../../external/dynamic';
import type { HTMLContentProps } from './types';

export const importBlockEditorHTMLContent = () =>
  import(
    /* webpackChunkName: "block-editor-html" */
    './HtmlContent'
  );
// const BlockEditorHTMLContent = lazy(importBlockEditorHTMLContent);

export const importHTMLContentVanilla = () =>
  import(
    /* webpackChunkName: "block-editor-html-vanilla" */
    './HTMLContentVanilla'
  );
// ssr: false — DOMPurify v3 needs a window object; skip SSR so sanitize runs only in the browser.
const HTMLContentVanilla = dynamic(importHTMLContentVanilla, { ssr: false, loading: () => null });

// using HTMLContentVanilla as default for now:
// the html content rendered by BlockEditorHTMLContent doesn't match the actual html content since tiptap expects properties in it's own format
// in salesforce tiptap editor is not working due to getSelection api breaking
// this is a preview component so for optimization we are using HTMLContentVanilla as default instead of BlockEditorHTMLContent rendered as readonly
const HtmlContent = forwardRef<HTMLDivElement, HTMLContentProps>(function HtmlContent(props, ref) {
  return <HTMLContentVanilla {...props} ref={ref} />;

  // const clientContext = useClientContext();

  // // todo: apply this check only for salesforce, since in salesforce tiptap editor is not working due to getSelection api breaking
  // if (clientContext?.client === ClientType.DeltaMatrix && clientContext.app === 'SALESFORCE') {
  //   return <HTMLContentVanilla {...props} ref={ref} />;
  // }

  // return <BlockEditorHTMLContent {...props} ref={ref} />;
});

export default withSuspense(HtmlContent);
